import {Inject, Injectable} from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {IsAuthorizedService} from './services/is-authorized.service';
import {tap} from 'rxjs/operators';
import {HeaderNotificationsService} from './header/header-notifications/header-notifications.service';
import {PlatformLocation} from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';
import {InsparkMessageService} from '@inspark/inspark-components';
import {Router} from '@angular/router';

@Injectable()
export class DevInterceptor implements HttpInterceptor {
  constructor(
    private messageService: InsparkMessageService,
    private snackBar: MatSnackBar,
    private isAuthorizedService: IsAuthorizedService,
    private ngxTranslateService: TranslateService,
    private platformLocation: PlatformLocation,
    private headerNotificationService: HeaderNotificationsService,
    private route: Router,
    @Inject('API_URL') private baseURL: string,
    @Inject('FILE_URL') private fileURL: string) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!environment.production) {
      request = request.clone({
        withCredentials: true
      });
    }
    let url = request.url;
    // todo временная залипух для ассетов и ссылок с указанным полным адресом сервиса
    if (url.indexOf(this.baseURL) !== 0 &&
      url.indexOf('/assets') !== 0 &&
      url.indexOf('/api') !== 0 &&
      url.indexOf('http://') !== 0 &&
      url.indexOf('https://') !== 0 &&
      url.indexOf('blob:') !== 0
      && (this.platformLocation.pathname === '/' || url.indexOf(this.platformLocation.pathname) !== 0)) {
      if (url[0] !== '/') {
        url = '/' + url;
      }
      url = url.indexOf('/files/') >= 0 ?  `${this.fileURL}${url}` : `${this.baseURL}${url}`;
    }

    if (request.method === 'POST' || request.method === 'PUT') {
      /* TODO раскомментарить по необходимости - Вадим экспериментирует с TZ на сервере */
      /* this.shiftDates(request.body); */
    }

    request = request.clone({url});
    return next.handle(request)
      .pipe(
        tap(
          (resp) => {
          },
          (err: HttpErrorResponse) => {

            if (err.error instanceof Error) {
              // A client-side or network error occurred. Handle it accordingly.
              console.error('An error occurred:', err.error.message);
            } else if (err.error instanceof Blob) {
              const reader: FileReader = new FileReader();
              reader.readAsText(err.error);
                reader.onloadend = (e) => {
                  const messageObject = JSON.parse(reader.result as string);
                  this.messageService.error(messageObject.Message);

                };
            } else {
              // The backend returned an unsuccessful response code.
              // The response body may contain clues as to what went wrong,

              // do something on error
              // let authService = $injector.get('authService');
              // let toastr = $injector.get('toastr');
              const gettext = (a) => a;


              switch (err.status) {
                case 401:
                  // SEM-3978: не надо делать обработку суперсетовского логина
                  if (err.url.indexOf('/api/v1/dashboard') >= 0 ||
                      err.url.indexOf('/auth/twofactorauth') >= 0) {
                    return;
                  }

                  if (this.isAuthorizedService.isAuthorized.getValue()) {
                    setTimeout(() => {
                      let currentUrl = '';
                      try {
                        currentUrl = window.location.href.split('#!')[1];
                      } catch (e) {
                        console.log(e.message);
                      }
                      window.location.href = '#!/login?backurl=' + currentUrl;
                    });
                  }
                  this.isAuthorizedService.isAuthorized.next(false);


                  if (err.error && err.error.Message) {
                    this.messageService.error(err.error.Message);
                  } else {
                    this.messageService.error(gettext('authorization failed'));
                  }
                  break;
                case 403:
                  if (err.error && err.error.Message) {
                    this.messageService.error(err.error.Message);
                  } else {
                    this.messageService.error(gettext('access denied'));
                  }
                  break;
                // SEM-7008: не обрабатывать 500-ую ошибку
                case 502:
                case 503:
                  if (err.error && err.error.Message) {
                    this.messageService.error(err.error.Message);
                  } else {
                    this.messageService.error(gettext('502 Error'));
                  }
                  this.route.navigate(['/502error']);
                  break;
                default:
                  if (err.error) {
                    if (err.error.Message) {
                      if (err.url.indexOf('reset_password?code=') === -1) {
                        if (Array.isArray(err.error.Details) && err.error.Details.length > 0) {
                          err.error.Details.forEach(detail => this.messageService.error(`${detail.Item || ''} ${detail.Problem || ''}`));
                        } else {
                          this.messageService.error(err.error.Message);
                        }
                      }
                      /*this.headerNotificationService.addMessage({
                        header: err.error.Message,
                        details: err.error.Details,
                        timestamp: Date.now()
                      });*/

                    } else if (err.message && err.message.indexOf('icon: 0 Unknown Error') > 0) {
                      this.messageService.error(`UNKNOWN IMAGE LOADING ERROR`);
                    } else if (err.message && err.message.toLowerCase().indexOf('request entity too large') > 0) {
                      this.messageService.error(`UNKNOWN IMAGE LOADING ERROR`);
                    } else if (err.message) {
                      console.log(err.message);
                      this.messageService.error(err.message);
                    }  else if (!err.message) {
                      this.messageService.error(`UNKNOWN ERROR`);
                    }

                  }
              }
              console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
              console.log('err:', err);

            }

          })
      );

  }

  shiftDates(body) {
    if (body === null || body === undefined) {
      return body;
    }

    if (typeof body !== 'object') {
      return body;
    }

    for (const key of Object.keys(body)) {
      const value = body[key];
      if (value instanceof Date) {
        body[key] = new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes()
          , value.getSeconds()));
      } else if (typeof value === 'object') {
        this.shiftDates(value);
      }
    }
  }
}
